import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  // eslint-disable-next-line class-methods-use-this
  reset({ params: { target, value } }) {
    const targetElement = document.getElementById(target);
    targetElement.value = value;
  }
}
